var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 2a6.71 6.71 0 016.67 6.7 6.6 6.6 0 01-2.87 5.43 10.51 10.51 0 016.11 6.58 1 1 0 01-.62 1.29.93.93 0 01-1.23-.62 8.46 8.46 0 00-16.16 0 .93.93 0 01-1.23.62.94.94 0 01-.62-1.24 10.52 10.52 0 016.1-6.58 6.64 6.64 0 01-2.86-5.47A6.73 6.73 0 0112 2zm0 2a4.69 4.69 0 100 9.43 4.69 4.69 0 000-9.37z"
})));

export default SvgIconUser;